import React from "react";
import Branding from "./Branding";
import MaintenanceHeader from "./Maintenance";
import Navigation from "./Navigation";

const Header = ({ maintenance = false, me = {}, loggedIn = false, isDark = false, toggleColorMode }) => {
  return (
    <header className="mb-4 flex-row align-center">
      <div className="container flex-row justify-space-between-lg justify-center align-center main-logo">
        <Branding />

        { maintenance ? (
          <MaintenanceHeader />
        ) : (
          <Navigation me={me} loggedIn={loggedIn} isDark={isDark} toggleColorMode={toggleColorMode} />
        )}

      </div>
    </header>
  );
};

export default Header;
